import type { ReactNode } from "react";

export type AlphabeticalSortOption = "az" | "za";

export type PublishedAtSortOption = "publishedAtAsc" | "publishedAtDesc";

export const alphabeticalSortOptions = [
  "az",
  "za",
] as const satisfies readonly AlphabeticalSortOption[];

export const publishedAtSortOptions = [
  "publishedAtAsc",
  "publishedAtDesc",
] as const satisfies readonly PublishedAtSortOption[];

export type JobSortField = "title" | "published_at";

export type SortDirection = "asc" | "desc";

export type JobSortOrder = {
  field: JobSortField;
  direction: SortDirection;
};

export const DEFAULT_ALPHABETICAL_SORT: AlphabeticalSortOption = "az";

export const DEFAULT_PUBLISHED_AT_SORT: PublishedAtSortOption =
  "publishedAtDesc";

export function buildJobSortOrder(
  alphabeticalSort: AlphabeticalSortOption | null,
  publishedAtSort: PublishedAtSortOption | null,
): JobSortOrder {
  if (publishedAtSort != null) {
    return {
      field: "published_at",
      direction: publishedAtSort === "publishedAtAsc" ? "asc" : "desc",
    };
  }
  if (alphabeticalSort) {
    return {
      field: "title",
      direction: alphabeticalSort === "az" ? "asc" : "desc",
    };
  }
  return { field: "published_at", direction: "desc" };
}

export type JobSearchFilterBadgesLabels = {
  badgeLanguagePrefix: string;
  badgeServicePrefix: string;
  badgeCityPrefix: string;
  badgeAlphabeticalPrefix: string;
  badgePublishedAtPrefix: string;
  sortAlphabeticalLabel: (option: AlphabeticalSortOption) => string;
  sortPublishedAtLabel: (option: PublishedAtSortOption) => string;
};

export type JobSearchFilterToolbarLabels = JobSearchFilterBadgesLabels & {
  filterBy: string;
  sortBy: string;
};

export type ModalSlotRenderProps = {
  className: string;
  isBlocking: boolean;
  onClose: () => void;
  onSubmit: () => void;
};

export type ToolbarButtonProps = {
  className?: string;
  variant?: string;
  href?: string;
  state?: unknown;
  type?: "button" | "submit" | "reset";
  onClick?: () => void;
  children?: ReactNode;
};

export type ToolbarBadgeProps = {
  className?: string;
  variant?: string;
  color?: string;
  size?: string;
  endIcon?: ReactNode;
  children?: ReactNode;
};
